// extracted by mini-css-extract-plugin
export default {"signup":"RegistrationStep_signup__bCRk-","wrapper":"RegistrationStep_wrapper__Ao-AT"};